import { Injectable } from '@angular/core';
import { BetonOrderCalcParams, BetonOrderCalcResult, BetonOrderFormInitialData, BetonOrderParams } from '@beton/const';
import { BetonActions, BetonSelectors, StateWithBeton } from '@beton/data-access';
import { Store } from '@ngrx/store';
import { HttpErrorModel, StateUtils } from '@spartacus/core';
import { Observable, filter } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BetonOrderService {
  constructor(private store: Store<StateWithBeton>) {}

  loadInitialData(): void {
    this.store.dispatch(new BetonActions.LoadBetonOrderInitialData());
  }

  calculateOrder(params: BetonOrderCalcParams): void {
    this.store.dispatch(new BetonActions.CalculateBetonOrder(params));
  }

  confirmOrder(params: BetonOrderParams): void {
    this.store.dispatch(new BetonActions.ConfirmBetonOrder(params));
  }

  getInitialDataState(): Observable<StateUtils.LoaderState<BetonOrderFormInitialData>> {
    return this.store.select(BetonSelectors.getBetonOrderInitialDataState()).pipe(filter(Boolean));
  }

  getCalculateOrderState(): Observable<StateUtils.LoaderState<BetonOrderCalcResult>> {
    return this.store.select(BetonSelectors.getCalculateOrderState()).pipe(filter(Boolean));
  }

  getCalculateOrderError(): Observable<HttpErrorModel> {
    return this.store.select(BetonSelectors.getCalculateOrderError());
  }

  getConfirmOrderState(): Observable<StateUtils.LoaderState<unknown>> {
    return this.store.select(BetonSelectors.getConfirmOrderState()).pipe(filter(Boolean));
  }

  getConfirmOrderError(): Observable<HttpErrorModel> {
    return this.store.select(BetonSelectors.getConfirmOrderError());
  }

  resetInitialDataState(): void {
    this.store.dispatch(new BetonActions.ResetBetonOrderInitialData());
  }

  resetCalcOrderState(): void {
    this.store.dispatch(new BetonActions.ResetBetonOrderCalcData());
  }

  resetConfirmOrderState(): void {
    this.store.dispatch(new BetonActions.ResetBetonOrderConfirmData());
  }
}
